import { createClient } from '@supabase/supabase-js'

const isDev = import.meta.env.MODE === 'development'
// Set VITE_USE_PROD_SUPABASE=true to use production Supabase in dev mode
const useProdSupabase = import.meta.env.VITE_USE_PROD_SUPABASE === 'true'

const useDevConfig = isDev && !useProdSupabase

const configuredSupabaseUrl = useDevConfig
  ? import.meta.env.VITE_DEV_SUPABASE_URL
  : import.meta.env.VITE_SUPABASE_URL

const supabaseAnonKey = useDevConfig
  ? import.meta.env.VITE_DEV_SUPABASE_ANON_KEY
  : import.meta.env.VITE_SUPABASE_ANON_KEY

if (!configuredSupabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables')
}

export const supabaseUrl = configuredSupabaseUrl

// Regular client (for auth, user-specific data)
export const supabase = createClient(supabaseUrl, supabaseAnonKey)

// Service role client (bypasses RLS, for admin metrics)
const supabaseServiceKey = useDevConfig
  ? import.meta.env.VITE_DEV_SUPABASE_SERVICE_ROLE_KEY
  : import.meta.env.VITE_SUPABASE_SERVICE_ROLE_KEY

if (!supabaseServiceKey) {
  console.warn('⚠️ VITE_SUPABASE_SERVICE_ROLE_KEY not found. Metrics will be filtered by RLS. Add it to .env.local to see ALL users\' data.')
}

export const supabaseAdmin = supabaseServiceKey
  ? createClient(supabaseUrl, supabaseServiceKey, {
      auth: { persistSession: false }
    })
  : supabase // Fallback to regular client if no service key
